export const PreferenceLabel = ({ label }: { label: string }) => {
  return <span className="w-64 mr-2 h-full whitespace-nowrap mb-[2px]">{label}</span>;
};
